import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Nav,
  Row,
  Tab,
  Alert,
  Spinner,
} from "react-bootstrap";
import TableData from "./component/tableData";
import CreatePlanTab from "./component/CreatePlans";
import add_new from "../../../Assets/svg/add_new.svg";
import AddNewPlan from "./component/Modal/AddNewPlan";
import { get, updateToken } from "../../../helpers/api_helper";
import { useSelector } from "react-redux";
import AddSubscriptionUser from "./component/Modal/AddSubscriptionUser";
import Pagination from "../../../components/Pagination";
import useCheckPermission from "../../../hooks/useCheckPermission";

const Subscription = () => {
  const token = useSelector((state) => state.login.token);
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [showAddPlanModal, setShowAddPlanModal] = useState(false);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [activeTab, setActiveTab] = useState("SubscriptionUser");

  const handleCreateSubscription = () => setShowAddPlanModal(true);
  const handleCloseAddPlanModal = () => setShowAddPlanModal(false);
  const handleAddUser = () => setShowAddUserModal(true);
  const handleCloseAddUserModal = () => setShowAddUserModal(false);

  const hasCreatePermission = useCheckPermission("subscription", "CREATE");

  const fetchSubscriptions = useCallback(
    async (page = 1) => {
      setLoading(true);
      setError(null);
      try {
        const response = await get(
          `/subs/fetch?skip=${(page - 1) * itemsPerPage}&limit=${itemsPerPage}`
        );
        if (response?.success) {
          setSubscriptionData(response?.data?.items || []);
          setTotalPages(response?.data?.totalPages || 1);
        } else {
          setError(response.message || "Failed to fetch content");
        }
      } catch (error) {
        setError("An error occurred while fetching data.");
      } finally {
        setLoading(false);
      }
    },
    [itemsPerPage]
  );

  useEffect(() => {
    if (token) {
      updateToken(token);
      fetchSubscriptions(currentPage);
    }
  }, [token, fetchSubscriptions, currentPage]);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <>
      <AddNewPlan
        show={showAddPlanModal}
        onHide={handleCloseAddPlanModal}
        resetFormOnClose={showAddPlanModal}
      />
      <AddSubscriptionUser
        show={showAddUserModal}
        onHide={handleCloseAddUserModal}
      />
      <section className="userSec position-relative py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="d-flex align-items-center sectionHeader justify-content-between gap-10 flex-wrap filterBtns">
                <div className="left">
                  <h4 className="m-0 fw-bold">Subscription Details</h4>
                  <p className="m-0 text-muted py-1">
                    It is a long established fact that a reader will be
                    distracted by the readable
                  </p>
                </div>
                <div className="right d-flex align-items-center flex-wrap gap-10">
                  {activeTab === "CreatePlans" && hasCreatePermission ? (
                    <Button
                      onClick={handleCreateSubscription}
                      className="d-flex align-items-center justify-content-center rounded-pill"
                    >
                      Create Subscription Plan
                      <span className="icn ms-2">
                        <img src={add_new} alt="" />
                      </span>
                    </Button>
                  ) : null}
                </div>
              </div>
            </Col>

            <Col lg="12" className="my-2">
              <Tab.Container
                id="left-tabs-example"
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
              >
                <div className="commonTable">
                  <div
                    className="top px-3 pt-2 d-flex align-items-center justify-content-between gap-10"
                    style={{ background: "#F5F7FA" }}
                  >
                    <div className="left">
                      <Nav
                        variant="pills"
                        className="transparentBtn-Tab underlineTab py-2 gap-10"
                      >
                        <Nav.Item>
                          <Nav.Link
                            eventKey="SubscriptionUser"
                            className="p-0 bg-transparent position-relative px-2"
                          >
                            Subscription User
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            eventKey="CreatePlans"
                            className="p-0 bg-transparent position-relative px-2"
                          >
                            Create Plans
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </div>
                  </div>
                  <Tab.Content>
                    <Tab.Pane eventKey="SubscriptionUser">
                      {loading ? (
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ height: "100px" }}
                        >
                          <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                        </div>
                      ) : error ? (
                        <Alert variant="danger">{error}</Alert>
                      ) : (
                        <>
                          <TableData subscriptionData={subscriptionData} />
                          {totalPages > 1 && (
                            <Pagination
                              currentPage={currentPage}
                              totalPages={totalPages}
                              onPageChange={handlePageChange}
                            />
                          )}
                        </>
                      )}
                    </Tab.Pane>
                    <Tab.Pane eventKey="CreatePlans">
                      <CreatePlanTab />
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Subscription;
